import { GAME_ASSET_SLUG } from "@/config/game";
import { cn } from "@/lib/utils";
import { playersSelector } from "@/redux/players/playersSlice";
import { useState } from "react";
import { useSelector } from "react-redux";

export const PlayStyle = ({
  hasPlus,
  hasNormal,
  id,
  large = false,
}: {
  hasPlus: boolean;
  hasNormal: boolean;
  id: number;
  large?: boolean;
}) => {
  const { playStylesDict } = useSelector(playersSelector);
  // Click reveals the full name as an overlay so the truncated label keeps
  // its slot and neighbours don't move.
  const [expanded, setExpanded] = useState(false);
  const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
  const imageUrl = hasPlus
    ? `${assetsBaseUrl}/${GAME_ASSET_SLUG}/playstylesplus/${id}.png`
    : `${assetsBaseUrl}/${GAME_ASSET_SLUG}/playstyles/${id}.png`;
  const name = playStylesDict[id]?.name;
  const labelClassName = cn(
    "text-center text-tiny bg-panel-background rounded-sm px-1",
    large ? "text-xs" : "text-[0.6rem]",
    !hasNormal && !hasPlus ? "text-dark-disabled" : "text-dark-secondary",
  );
  return (
    <div
      className="flex flex-col items-center cursor-pointer"
      onClick={() => setExpanded((e) => !e)}
    >
      <img
        key={id}
        src={imageUrl}
        alt={`PlayStyle ${id}`}
        className={cn(
          large ? "w-10 h-10" : "w-8 h-8",
          !hasNormal && !hasPlus ? "opacity-15" : "",
        )}
      />
      <div className="relative -mt-1">
        <div
          className={cn(
            labelClassName,
            "truncate",
            large ? "w-14 large-desktop:w-16" : "w-12",
          )}
        >
          {name}
        </div>
        {expanded && (
          <div
            className={cn(
              labelClassName,
              "absolute top-0 left-1/2 -translate-x-1/2 whitespace-nowrap z-10 shadow-md",
            )}
          >
            {name}
          </div>
        )}
      </div>
    </div>
  );
};
